module.exports = __webpack_public_path__ + "img/ks.7ab85a82.svg";